/* Shortcut.tsx generated by @compiled/babel-plugin v0.36.1 */
import "./Shortcut.compiled.css";
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
import { formatShortcut } from '@atlaskit/editor-common/keymaps';
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
var styleUnbounded = null;
var style = null;
/** Component that displays a formatted keyboard shortcut. */
export function Shortcut(_ref) {
  var shortcut = _ref.shortcut;
  var formattedShortcut = formatShortcut(shortcut);
  return /*#__PURE__*/React.createElement("span", {
    className: ax(["_2rkoiti9 _syaz1gjq _bfhkm7j4 _k48pi7a9", "_ca0q1l7b _u5f31l7b _n3td1l7b _19bv1l7b _18u0i2wt"])
  }, formattedShortcut);
}